const React = require('react');
const isNode = (typeof process !== 'undefined');
const Select = isNode ? require('react-select') : <div/>;
const Input = require('./../../FormComponents/Input');

class Oppsigelse extends React.Component {
    constructor(props) {
        super(props);
    }
    getValues() {
        return {
            address: this.address.value,
            apartmentNumber: this.apartmentNumber.value,
            comment: this.comment.value,
            orgNum: this.orgNum.value,
        }
    }
    render() {
        const {hideHeaders, color} = this.props;

        return (
        <div className={`forms__inputContainer forms__inputContainer--${color}`}>
            {!hideHeaders && <h2 className="forms__formHeader">Oppsigelse av leieforhold</h2>}
            <div className="forms__formElement">
                <Input validations="minLength:1" required name="address" type="text" placeholder="Adresse" ref={(address) => this.address = address}/>
            </div>
            <div className="forms__formElement">
                <Input name="apartmentNumber" type="text" placeholder="Leilighetsnummer" ref={(apartmentNumber) => this.apartmentNumber = apartmentNumber}/>
            </div>
            <div className="forms__formElement">
                <Input validations="minLength:1" name="orgNum" type="text" placeholder="Org.nr" ref={(orgNum) => this.orgNum = orgNum}/>
            </div>
            <div className="forms__formElement">
                <label className="form-label">Årsak til oppsigelse</label>
                <textarea placeholder="Årsak til oppsigelse" ref={(comment) => this.comment = comment}/>
            </div>
        </div>
        )
    }
}

module.exports = Oppsigelse;



// WEBPACK FOOTER //
// ./src/main/resources/site/parts/Forms/forms/Oppsigelse/index.jsx